import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonToggleModule } from '@angular/material/button-toggle';

import { ButtonToggleSelect } from './button-toggle-select.component';

@NgModule({
  declarations: [
    ButtonToggleSelect,
  ],
  imports: [
    CommonModule,
    MatButtonToggleModule,
  ],
  exports: [
    ButtonToggleSelect,
  ],
})
export class ButtonToggleSelectModule { }
